import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
} from './common.js';

export const ChartingSelectionsReducer = () => [];

export const ChartingSelectionsAggregator = () => [];

export default {
  AggregateMap: GlobalAggregateMap(ChartingSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(ChartingSelectionsReducer),
};
